export default __webpack_public_path__ + "static/media/LogoHarfonEspanol.72638e7a.png";